/** EOJ ID */
export const EOJ_ID = {
  /** 電子レンジ */
  MICRO_WAVE_OVEN: "03B8",
  /** 炊飯器 */
  RICE_COOKER: "03BB",
  /** 自動計量炊飯器 */
  RICE_COOKER_AUTO_WEIGHTING: "03FA",
  /** IHクッキングヒーター */
  IH_COOKING_HEATER: "03B9",
  /** 卓上IH */
  DESKTOP_IH: "03PH",
  /** オートクッカー */
  AUTO_COKKER: "03AC",
  /** 冷蔵庫 */
  FRIRDGE: "03B7",
  /** カメラ */
  CAMERA: "0604"
} as const;
